import { combineReducers } from "redux";

//::::::::: VIVN USER :::::::::::
import userAuthReducer from "./user/auth/user_auth.reducer";
import loginReducer from "./user/login/login.reducer";

//::::::::: VIVN BAILIFF :::::::::::
import defaultBailiffReducer from "./bailiff/draft/bailiff/default_bailiff.reducer";
import draftDialogReducer from "./bailiff/draft/dialog/draft_dialog.reducer";
import orderBailiffReducer from "./bailiff/payment/order/order_bailiff.reducer";
import bailiffAuthReducer from "./bailiff/auth/bailiff_auth.reducer";
import defaultClientReducer from "./user/(default)/client/default_client.reducer";
import navReducer from "./bailiff/nav/nav.reducer";
import financeResellerReducer from "./bailiff/finance/reseller/finance_reseller.reducer";
import financeLifeReducer from "./bailiff/finance/life/life.reducer";
import defaultBankReducer from "./bailiff/default/bank/default_bank.reducer";
import settingWithdrawReducer from "./bailiff/default/withdraw/setting_withdraw.reducer";
import defaultWalletReducer from "./bailiff/default/wallet/default_wallet.reducer";
import paymentWithdrawReducer from "./bailiff/payment/withdraw/payment_withdraw.reducer";

const rootReducer = combineReducers({
  //auth
  userAuthReducer,
  bailiffAuthReducer,
  //
  loginReducer,

  defaultClientReducer,

  // draft
  defaultBailiffReducer,
  draftDialogReducer,

  // finance
  financeResellerReducer,
  financeLifeReducer,

  //banks
  paymentWithdrawReducer,
  defaultBankReducer,

  //setting.
  settingWithdrawReducer,

  //wallet
  defaultWalletReducer,

  //order
  orderBailiffReducer,
  //nav
  navReducer,
});

export default rootReducer;
